
import React from 'react';
import { optimizedImage } from '@/utils/imageOptimizer';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section 
      className="min-h-screen pt-24 pb-16 flex flex-col justify-center"
      style={{ 
        background: "linear-gradient(180deg, rgba(240,241,247,0.8) 0%, rgba(255,255,255,1) 100%)"
      }}
    >
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-10 md:gap-16">
          <div className="flex-1 max-w-2xl">
            <div className="space-y-6">
              <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-brand-darkgrey leading-tight">
                Your priority candidate list.<br />
                <span className="text-brand-blue">Ready in minutes.</span>
              </h1>
              
              <h2 className="text-xl text-brand-grey max-w-xl">
                In 2026, you don't need thousands of applications. Use Cutshort to find top few candidates that actually match your requirements and can join your team fast.
              </h2>
              
              <div className="flex flex-col sm:flex-row gap-4 pt-4">
                <a 
                  href="https://cutshort.io/?auth=employer"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center bg-brand-blue text-white px-8 py-4 rounded-full text-lg font-medium hover:bg-brand-blue/90 transition-colors"
                >
                  Start for free
                  <ArrowRight className="w-5 h-5 ml-2" />
                </a>
                <a
                  href="https://cutshort.io/a/generic-emp-form"
                  target="_blank"
                  rel="noopener noreferrer" 
                  className="flex items-center justify-center gap-2 px-8 py-4 rounded-full text-lg font-medium text-brand-blue border border-brand-blue/30 hover:border-brand-blue/60 hover:bg-brand-blue/5 transition-colors"
                >
                  Get a callback
                </a>
              </div>
            </div>
            
            <div className="mt-12">
              <h3 className="text-sm font-medium text-brand-darkgrey mb-4">Powered tech talent sourcing for...</h3>
              <div className="flex flex-wrap items-center gap-8 mt-2">
                <img 
                  {...optimizedImage(
                    "/lovable-uploads/7d1ccd03-2690-4a11-9f91-d42bb6d5a308.png",
                    "Fractal",
                    "h-8 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity"
                  )}
                />
                <img 
                  {...optimizedImage(
                    "/lovable-uploads/68024710-3e67-4a2b-866d-21d0cd49b4b0.png",
                    "Shiprocket",
                    "h-8 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity"
                  )}
                />
                <img 
                  {...optimizedImage(
                    "/lovable-uploads/32334656-9272-41cd-b728-c0ce02ee72f0.png",
                    "Sprinto",
                    "h-8 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity"
                  )}
                />
                <img 
                  {...optimizedImage(
                    "/lovable-uploads/f0e559de-57be-429d-8fc3-fdb35842aa81.png",
                    "StepSecurity",
                    "h-8 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity"
                  )}
                />
              </div>
            </div>
          </div>
          
          <div className="flex-1 w-full max-w-lg">
            <div className="relative animate-float">
              <div className="glass-card p-6 rounded-2xl shadow-xl">
                <div className="bg-brand-offwhite p-5 rounded-xl mb-4">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="h-10 w-10 rounded-full overflow-hidden">
                      <img 
                        {...optimizedImage(
                          "/lovable-uploads/4b3bea26-06d2-4efd-a04b-f6046d794008.png",
                          "Noel",
                          "h-full w-full object-cover",
                          "eager"
                        )}
                      />
                    </div>
                    <div>
                      <h3 className="font-semibold text-brand-darkgrey">Noel from Cutshort</h3>
                      <p className="text-xs text-brand-grey">Just now</p>
                    </div>
                  </div>
                  <p className="text-sm text-brand-darkgrey">
                    14 new candidates ready for review for your Senior React Developer role
                  </p>
                </div>
                
                <div className="space-y-3">
                  <div className="flex gap-3 items-center">
                    <div className="h-8 w-8 rounded-full bg-brand-blue/20"></div>
                    <div className="flex-1 h-12 bg-brand-offwhite rounded-lg"></div>
                  </div>
                  <div className="flex gap-3 items-center">
                    <div className="h-8 w-8 rounded-full bg-brand-blue/20"></div>
                    <div className="flex-1 h-12 bg-brand-offwhite rounded-lg"></div>
                  </div>
                  <div className="flex gap-3 items-center">
                    <div className="h-8 w-8 rounded-full bg-brand-blue/20"></div>
                    <div className="flex-1 h-12 bg-brand-offwhite rounded-lg"></div>
                  </div>
                </div>
                
                <div className="mt-5 flex justify-between">
                  <button className="bg-brand-blue text-white px-4 py-2 rounded-lg text-sm">
                    View Candidates
                  </button>
                  <button className="border border-brand-grey/30 text-brand-grey px-4 py-2 rounded-lg text-sm">
                    Request More
                  </button>
                </div>
              </div>
              
              <div className="absolute -bottom-6 -left-6 h-24 w-24 rounded-full bg-brand-yellow/30 blur-xl"></div>
              <div className="absolute -top-6 -right-6 h-16 w-16 rounded-full bg-brand-blue/20 blur-xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
